import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://test.api.schenck.one/acm',
  redirectUrl: 'https://so-acm-test.azureedge.net/',
  clientId: '21ba9340-c470-476e-bacb-b6ad54a23d36',
  authority: 'https://login.microsoftonline.com/36515c62-8878-4f10-a7f4-561a4c17bef7',
  scope: 'api://21ba9340-c470-476e-bacb-b6ad54a23d36/ACM.API',
};
